/* Millesève — tiroir mobile du Tirage (E1.5, DS §10.1, §14). Rendu par snippets/header-drawer.liquid.
   Un <dialog> ouvert en modal : le reste de la page devient inerte. Ce script ajoute le glissement,
   la fermeture par la croix, le voile ou Échap, le focus gardé dans le panneau et rendu au burger. */
if (!customElements.get('ms-tiroir')) {
  class MsTiroir extends HTMLElement {
    connectedCallback() {
      this.burger = this.querySelector('[data-tiroir-ouvrir]');
      this.dialogue = this.querySelector('dialog');
      this.panneau = this.querySelector('.ms-tiroir__panneau');
      if (!this.burger || !this.dialogue || !this.panneau) return;

      this.burger.addEventListener('click', () => this.ouvre());
      this.querySelectorAll('[data-tiroir-fermer]').forEach((el) => el.addEventListener('click', () => this.ferme()));
      // Échap : on garde la main pour faire glisser le panneau avant de fermer.
      this.dialogue.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.ferme();
      });
      // Fermeture par n'importe quel chemin (y compris un Échap que le navigateur n'a pas laissé annuler).
      this.dialogue.addEventListener('close', () => this.remet());
      this.dialogue.addEventListener('keydown', (event) => this.garde(event));

      this.large = window.matchMedia('(min-width: 750px)');
      this.surLarge = (event) => {
        if (event.matches) this.ferme();
      };
      this.large.addEventListener('change', this.surLarge);
    }

    disconnectedCallback() {
      if (this.large) this.large.removeEventListener('change', this.surLarge);
      clearTimeout(this.minuteur);
    }

    ouvre() {
      if (this.dialogue.open) return;
      this.dialogue.showModal();
      this.burger.setAttribute('aria-expanded', 'true');
      this.panneau.getBoundingClientRect(); // pose l'état fermé avant la transition
      this.dialogue.classList.add('est-ouvert');
      // preventScroll (E7.7) : sans lui, le navigateur faisait défiler le dialogue pour montrer ce lien,
      // encore hors écran : le panneau apparaissait d'un coup puis glissait de travers.
      const premier = this.panneau.querySelector('.ms-tiroir__index a') || this.focusables()[0];
      if (premier) premier.focus({ preventScroll: true });
    }

    ferme() {
      if (!this.dialogue.open || !this.dialogue.classList.contains('est-ouvert')) return;
      this.dialogue.classList.remove('est-ouvert');
      // durée du glissement (0 en mouvement réduit : les jetons mettent --dur-fast à 0s)
      const duree = parseFloat(getComputedStyle(this.panneau).transitionDuration) * 1000 || 0;
      clearTimeout(this.minuteur);
      this.minuteur = setTimeout(() => {
        this.dialogue.close();
        this.remet(); // sans attendre l'évènement close, que le navigateur peut différer
      }, duree);
    }

    remet() {
      clearTimeout(this.minuteur);
      if (this.burger.getAttribute('aria-expanded') === 'false') return;
      this.dialogue.classList.remove('est-ouvert');
      this.burger.setAttribute('aria-expanded', 'false');
      if (this.burger.offsetParent !== null) this.burger.focus({ preventScroll: true });
    }

    focusables() {
      return Array.from(
        this.panneau.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.offsetParent !== null || el.getClientRects().length > 0);
    }

    // Tab et Maj+Tab tournent dans le panneau, sans passer par la page ni par la barre du navigateur.
    garde(event) {
      if (event.key !== 'Tab') return;
      const liste = this.focusables();
      if (!liste.length) return;
      const premier = liste[0];
      const dernier = liste[liste.length - 1];
      const actif = document.activeElement;
      if (event.shiftKey && (actif === premier || !this.panneau.contains(actif))) {
        event.preventDefault();
        dernier.focus();
      } else if (!event.shiftKey && (actif === dernier || !this.panneau.contains(actif))) {
        event.preventDefault();
        premier.focus();
      }
    }
  }

  customElements.define('ms-tiroir', MsTiroir);
}
